var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_81_754)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2,
    width: 53,
    height: 53,
    rx: 26.5,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_81_754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4518 12.2836H15.3393C14.6614 12.2836 14.0114 12.5528 13.5321 13.0321C13.0528 13.5114 12.7836 14.1614 12.7836 14.8393V42.9518C12.7836 43.6296 13.0528 44.2796 13.5321 44.7589C14.0114 45.2382 14.6614 45.5075 15.3393 45.5075H43.4518C44.1296 45.5075 44.7796 45.2382 45.2589 44.7589C45.7382 44.2796 46.0075 43.6296 46.0075 42.9518V14.8393C46.0075 14.1614 45.7382 13.5114 45.2589 13.0321C44.7796 12.5528 44.1296 12.2836 43.4518 12.2836ZM43.4518 42.9518H15.3393V14.8393H43.4518V42.9518ZM24.2841 26.3398V36.5626C24.2841 36.9015 24.1495 37.2265 23.9099 37.4661C23.6702 37.7058 23.3452 37.8404 23.0063 37.8404C22.6674 37.8404 22.3424 37.7058 22.1027 37.4661C21.8631 37.2265 21.7285 36.9015 21.7285 36.5626V26.3398C21.7285 26.0009 21.8631 25.6759 22.1027 25.4363C22.3424 25.1966 22.6674 25.062 23.0063 25.062C23.3452 25.062 23.6702 25.1966 23.9099 25.4363C24.1495 25.6759 24.2841 26.0009 24.2841 26.3398ZM38.3404 30.8123V36.5626C38.3404 36.9015 38.2058 37.2265 37.9661 37.4661C37.7265 37.7058 37.4015 37.8404 37.0626 37.8404C36.7237 37.8404 36.3986 37.7058 36.159 37.4661C35.9193 37.2265 35.7847 36.9015 35.7847 36.5626V30.8123C35.7847 29.965 35.4481 29.1525 34.849 28.5533C34.2499 27.9542 33.4374 27.6177 32.5901 27.6177C31.7429 27.6177 30.9303 27.9542 30.3312 28.5533C29.7321 29.1525 29.3955 29.965 29.3955 30.8123V36.5626C29.3955 36.9015 29.2609 37.2265 29.0212 37.4661C28.7816 37.7058 28.4566 37.8404 28.1177 37.8404C27.7788 37.8404 27.4537 37.7058 27.2141 37.4661C26.9745 37.2265 26.8398 36.9015 26.8398 36.5626V26.3398C26.8414 26.0268 26.9578 25.7253 27.167 25.4924C27.3761 25.2596 27.6635 25.1116 27.9745 25.0765C28.2855 25.0414 28.5986 25.1218 28.8544 25.3022C29.1101 25.4827 29.2907 25.7507 29.362 26.0555C30.2264 25.4691 31.2342 25.1292 32.2773 25.0724C33.3203 25.0156 34.3591 25.2439 35.2821 25.7329C36.2052 26.222 36.9776 26.9532 37.5164 27.8481C38.0552 28.743 38.3401 29.7677 38.3404 30.8123ZM24.9231 21.8674C24.9231 22.2465 24.8106 22.6171 24.6 22.9323C24.3894 23.2475 24.0901 23.4932 23.7398 23.6382C23.3896 23.7833 23.0042 23.8213 22.6324 23.7473C22.2605 23.6734 21.919 23.4908 21.6509 23.2227C21.3829 22.9547 21.2003 22.6131 21.1264 22.2413C21.0524 21.8695 21.0904 21.4841 21.2354 21.1339C21.3805 20.7836 21.6262 20.4843 21.9414 20.2737C22.2566 20.063 22.6272 19.9506 23.0063 19.9506C23.5147 19.9506 24.0022 20.1526 24.3617 20.512C24.7211 20.8715 24.9231 21.359 24.9231 21.8674Z",
    fill: "#1C1C1C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_81_754",
    x: 0.5,
    y: 0,
    width: 57,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81_754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81_754",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_81_754",
    x: 10.7836,
    y: 10.2836,
    width: 37.2239,
    height: 37.2239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81_754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81_754",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSocial);
export default __webpack_public_path__ + "static/media/linkedinSocial.442c684faa61ffc7b6168865675b63a0.svg";
export { ForwardRef as ReactComponent };